import log from 'loglevel'
import axios from 'axios'
import Cache from '../utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class Warranty {
  constructor() {
    log.info('[INFO] Initialize Warranty SubModule')
    this.cache = new Cache()
  }

  fetchWarranties(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params: {
          p: params.p,
          page_size: params.page_size,
          search: params.q,
        },
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/product/warranty/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch warranty')
            resolve(response.data)
          })
          .catch(err => {
            log.error('[ERROR] Fail to fetch warranty')
            log.error(err)
            reject(err.response)
          })
      })

      return promise
    })

    return result
  }

  fetchWarranty(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/product/warranty/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch warranty')
          resolve(response)
        })
        .catch(err => {
          log.error('[ERROR] Fail to fetch warranty')
          log.error(err)
          reject(err.response)
        })
    })
  }

  updateWarranty(id, warrantyData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/product/warranty/${id}/`, warrantyData)
        .then(response => {
          log.debug('[DEBUG] Success to update warranty')
          this.cache.reset()
          resolve(response)
        })
        .catch(err => {
          log.error('[ERROR] Fail to update warranty')
          log.error(err)
          reject(err.response)
        })
    })
  }

  addWarranty(warrantyData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/product/warranty/', warrantyData)
        .then(response => {
          log.debug('[DEBUG] Success to add warranty')
          this.cache.reset()
          resolve(response)
        })
        .catch(err => {
          log.error('[ERROR] Fail to add warranty')
          log.error(err)
          reject(err.response)
        })
    })
  }

  deleteWarranty(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/product/warranty/${id}/`)
        .then(() => {
          log.debug(`[DEBUG] Success to delete warranty with id: ${id}`)
          this.cache.reset()
          resolve()
        })
        .catch(err => {
          log.error('[ERROR] Fail to delete warranty')
          log.error(err)
          reject(err.response)
        })
    })
  }
}
